import { render, staticRenderFns } from "./ChipLabelCuenta.vue?vue&type=template&id=8fb0326e&"
import script from "./ChipLabelCuenta.vue?vue&type=script&lang=js&"
export * from "./ChipLabelCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports